module.exports = __webpack_public_path__ + "./fonts/googlelogo.d7f092af888a54de79ed9c9303d689d7.svg";